import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { Button } from 'shared/ui/button'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import s from './styles.module.scss'

export const FavoritesSuccessModal = () => {
  const { t } = useTranslation()
  const { closeDialog } = useDialogBottomSheet()

  return (
    <div className={s.container}>
      <AppIcon
        id={AllIcons.HEART_BIG}
        width={38}
        height={38}
        color={'#FF3144'}
      />

      <div className={s.info}>
        <p className={clsx('bold-22', s.title)}>
          {t('favorites_block.success_modal.title')}
        </p>
        <p className={clsx('medium-14', s.text)}>
          {t('favorites_block.success_modal.subtitle')}
        </p>

        <Button
          className={s.button}
          borderRadius="md"
          onClick={closeDialog}
        >
          {t('favorites_block.good')}
        </Button>
      </div>
    </div>
  )
}
